/* External Imports */
import { Box, Grid, Image, Link, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
import { mixPanel } from '@utils/Mixpanel';

/**
 * Renders the Header section
 * @param {Array} headerData - Data for section
 * @param {string} region - Region of the page
 * @param {string} language - Language of the page 
 * @returns {ReactElement} YantraHeader component
 */
const YantraHeader = ({ headerData, region, language }) => {

    const router = useRouter();
    // Mixpanel
    function iaminterested()
    {   
        MixpanelTrigger('iso_lead_interested_cta_clicked');
        //Form load
        if(router.asPath.indexOf('#program-fee')) {
          MixpanelTrigger('iso_lead_form_impression');
        }
    }
    function MixpanelTrigger(eventkey){
      const Mixpanel = mixPanel(router.asPath);
        Mixpanel.track(eventkey, {
          page_name: document.title,
          program_name: 'Yantra_Ceremony'
        });
    }
  return (
    <>
      <Box pos="relative" bgColor={{ base: '#0D0D0D', md: '#0D0D0D' }}>
        <Box
          className="bg"
          maxWidth={{ base: '', md: '998px', lg: '1170px' }}
          backgroundImage={{
            base: `url('${headerData[1]?.mobileImage?.url}') !important`,
            md: `url('${headerData[1]?.image?.url}') !important`,
          }}
          backgroundPosition={{ base: 'top center', md: 'right center' }}
          backgroundSize={{ base: 'contain' }}
          backgroundRepeat="no-repeat"
          max-width={{ lg: '1440px', base: '100%' }}
          margin="0 auto"
        >
          <Box
            w="100%"
            margin="0 auto"
            maxWidth={{ base: '', md: '998px', lg: '1170px' }}
            p={{ base: '0px 20px', md: '10px' }}
            textAlign={{ base: 'center', md: 'left' }}
            fontFamily="FedraSansStd-book"
          >
            <Grid
              templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
            >
              <Box width={{ base: '100%', lg: '470px', md: '380px' }}>
                <Box textAlign="left">
                  <Link
                    href={refineUrlDomain(headerData[7].text, region, language)}
                  >
                    <Image
                      src={headerData[0]?.image?.url}
                      alt={headerData[0]?.image.alt}
                      title={headerData[0]?.image?.title}
                      mb="50px"
                      pt="16px"
                    />
                  </Link>
                </Box>
                <Text
                  fontFamily="FedraSansStd-A-medium, sans-serif"
                  color="#fff"
                  fontSize={{ base: '36px', md: '50px' }}
                  lineHeight={{ base: '43px', md: '60px' }}
                  mb="30px"
                  as="h1"
                  mt={{ base: '250px', md: '0' }}
                >
                  {headerData[2].titleText}
                </Text>

                <Text
                  color="#fff"
                  mb={{ base: '20px', md: '35px' }}
                  fontSize="16px"
                  className="yantra-structure"
                >
                  {StructuredTextContent(headerData[3].body)}
                </Text>

                <Box
                  fontFamily="FedraSansStd-medium"
                  color="#fff"
                  fontSize={{ base: '24px', md: '28px' }}
                  mb="20px"
                >
                  {headerData[4].text}
                </Box>

                <Link
                  // href={headerData[5].linkUrl}
                  href={refineUrlDomain(
                    headerData[5].linkUrl,
                    region,
                    language
                  )}
                  onClick={() => iaminterested()}
                  bgColor="#FFCB12"
                  color="#28231E"
                  mb="30px"
                  padding="15px 30px"
                  borderRadius="5px"
                  display="inline-block"
                  fontFamily="FedraSansStd-medium"
                  _hover={{
                    bgColor: '#FFCB12',
                    textDecoration: 'none',
                  }}
                  _focus={{
                    bgColor: '#FFCB12',
                    textDecoration: 'none',
                  }}
                  _active={{
                    bgColor: '#FFCB12',
                    textDecoration: 'none',
                  }}
                >
                  {' '}
                  {headerData[5].buttonText}
                </Link>
                <Box className="yantra-structure" color="#fff">
                  {StructuredTextContent(headerData[6].body)}
                </Box>
              </Box>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default YantraHeader;
